import Axios from 'axios'
import { checkBrowser } from '../channel/setUserChannel'
import { handleOptions } from '../handleOptions/fetchHelper'
import { Indicator, Toast } from 'mint-ui'
import qs from 'qs'

const axios = Axios.create({
  timeout: 10000,
  baseURL: process.env.VUE_APP_AXIOS_URL,
  // 这里对数据进行了处理之后，破坏了axios根据数据类型设置Content-Type机制，所以一定要自己传header头进去，axios默认是application/x-www-form-urlencoded
  // 这里设置的默认是application/json, 如果使用其他类型的header头，请务必要传对应的Content-Type进去
  transformRequest: [function (data, headers) {
    if (headers['Content-Type'] && headers['Content-Type'].includes('application/x-www-form-urlencoded')) {
      return qs.stringify(data)
    } else {
      if (!headers['Content-Type']) {
        headers['Content-Type'] = 'application/json'
      }
      return JSON.stringify(data)
    }
  }]
})

// 自定义header
const headers = {
  'USER-CHANNEL': checkBrowser()
}

function setToken (token) {
  headers['AUTH-TOKEN'] = token
}
// const token = 'eyJhbGciOiJIUzI1NiJ9.eyJVU0VSX0NIQU5ORUwiOiJBTElQQVkiLCJJU1NVRVJfQVQiOjE1NTM3NjIyMzA3MjMsIk9QRU5fSUQiOiJsb2NhbCIsIklTU1VFUiI6Im5ldy1nZW5lcmF0aW9uLWFwaSIsIlBIT05FX0lEIjoiIiwiUEhPTkUiOiIxODgxOTIwNTUwMyIsIlVTRVJfSUQiOiJkMjc4YjcwOTFmZjI0MTFkODMyOGFkZTlkNDY3ODA2YiIsImV4cCI6MTU1NDY1MTI2M30.Q-Ja2OQ7pKsZp5_urng_WL6Noy8YKJoaXPECd9LtEyM'
// setToken(token)
axios.interceptors.request.use(
  config => {
    if (config.hasOwnProperty('loading')) {
      config.loading.text
        ? Indicator.open({
          text: config.loading.text,
          spinnerType: config.loading.spinnerType
        })
        : Indicator.open()
    }
    return config
  }
)
axios.interceptors.response.use(response => {
  Indicator.close()
  return response
}, err => {
  // 这里最好resolve掉服务器错误这种情况，省得之后还要catch
  Indicator.close()
  return Promise.resolve(err)
})

function handleResponse (response) {
  return new Promise(resolve => {
    if (!response) {
      resolve(false)
      return
    }

    // 一般的错误直接Toast出来就可以了，如果不需要Toast，请写进passStrictCode里面
    const passStraightCode = []
    if (response.data.code === '000000' || passStraightCode.includes(response.data.code) || response.data.success) {
      resolve(response)
      return response
    } else {
      Toast(response.data.msg || '出了点小差，请稍后再试')
      resolve(false)
      return false
    }
  })
}

// 请求头Content-Type默认为application/json
function customerizePost (options = {}) {
  const defaultConfig = {
    headers,
    method: 'post'
  }
  //  data不需要进行遍历merge,merge是深拷贝，如果data数据量庞大，影响性能，而且拷贝data根本是没必要的
  const data = options.data || {}
  if (options.data) {
    delete options.data
  }
  const config = handleOptions(defaultConfig, options)
  return axios({
    ...config,
    data
  }).then(res => {
    return res
  }).catch(err => {
    console.dir(err)
    return false
  })
}

function basePost (url, data, header) {
  Indicator.open()
  const defaultConfig = {
    method: 'post',
    headers
  }
  const options = {
    url,
    headers: {
      'Content-Type': header || 'application/json'
    }
  }
  // data不需要进行遍历merge
  const config = handleOptions(defaultConfig, options)
  return axios({
    ...config,
    data
  }).then(res => {
    Indicator.close()
    return handleResponse(res)
  }).catch(err => {
    Indicator.close()
    console.dir(err)
    return false
  })
}

function post (...params) {
  if (!params || !params.length) return false

  if (params.length && typeof params[0] === 'object') {
    return customerizePost(params[0])
  }

  if (params.length && typeof params[0] === 'string') {
    // 使用这种方式调用请确保对对应参数的位置
    return basePost(params[0], params[1] || {}, params[2])
  }
}

function baseGet (url, params, header) {
  Indicator.open()
  const defaultConfig = {
    method: 'get'
  }
  const options = {
    url
  }
  const config = handleOptions(defaultConfig, options)
  return axios({
    ...config,
    params
  }).then(res => {
    Indicator.close()
    return handleResponse(res)
  }).catch(err => {
    Indicator.close()
    console.dir(err)
    return false
  })
}

function customerizeGet (options = {}) {
  const defaultConfig = {
    headers,
    method: 'get'
  }
  const params = options.params || {}
  if (options.params) {
    delete options.params
  }
  const config = handleOptions(defaultConfig, options)
  return axios({
    ...config,
    params
  }).then(res => {
    return res
  }).catch(err => {
    console.dir(err)
    return false
  })
}

function get (...params) {
  if (!params || !params.length) return false

  if (params.length && typeof params[0] === 'object') {
    return customerizeGet(params[0])
  }

  if (params.length && typeof params[0] === 'string') {
    return baseGet(params[0], params[1] || '', params[2])
  }
}

export default {
  get,
  post,
  setToken
}
